const updateBackupStr = {
  toastr: 'Backup atualizado',
  toastrError: 'Falha ao atualizar'
};

export default updateBackupStr;
